import { FC } from "react";
import { Popover } from "antd";
import { classname } from "@ctra/utils";

import { Icon, CheckCircle } from "../../../../../elements";
import styles from "./Checkbox.module.less";

export interface CheckboxProps {
  /**
   * checked status
   */
  checked?: boolean;
  /**
   * popover label
   */
  label?: string;
}

/**
 * Checkbox component for game plans
 * @param {number | string | undefined} propName
 * @return {JSX.Element}
 * @constructor
 */
const Checkbox: FC<CheckboxProps> = ({ label, checked }) => {
  /**
   * @type {JSX.Element}
   */
  const icon = (
    <Icon
      component={CheckCircle}
      className={classname(
        "ctra-gamePlan-checkbox",
        styles.Checkbox,
        checked ? styles.Checked : styles.Unchecked
      )}
    />
  );

  return label ? <Popover content={label}>{icon}</Popover> : icon;
};

export default Checkbox;
